<template lang="pug">
#modal-opcoes-laudo
    el-form.p-0.mt-0(label-position='top', size='small')
        el-form-item(
            :label='$t("laudos.selecioneBaseDeDadosDesejadaParaCriacaoDeLaudo")'
        )
            el-radio-group(v-model='dadosBase', @change='exibirOutrosCampos')
                el-radio-button(label='DADOS_ATUALIZADOS') {{ $t('laudos.dadosAtualizadosUltimaSafra') }}
                el-radio-button(label='DADOS_HISTORICOS') {{ $t('laudos.dadosHistoricosSafra') }}

        el-form-item(
            :label='$t("laudos.selecioneTipoDeInsumoParaCriacaoDeLaudo")'
        )
            el-radio-group.radio-group-container(
                v-model='tipoInsumo',
                @change='exibirOutrosCampos'
            )
                el-radio.pr-5(label='TERRITORIO') {{ $t('laudos.territorio') }}
                el-radio.pr-5(label='ARQUIVO_VETORIAL') {{ $t('laudos.arquivoVetorialKml') }}
                el-radio(label='ARQUIVO_PDF') {{ $t('laudos.arquivoPdf') }}

        label.mb-4(v-if='showPrazo') {{ $t('laudos.prazoEstimadoGeracaoLaudo') }}: {{ prazo }}

        SelecionarTerritorio(
            v-if='showSelecaoTerritorio',
            @getTerritoriosSelecionados='solicitarLaudos',
            @cancelar-modal='closeDialog',
            :tipoLaudo='tipoLaudoCroqui'
        )

        el-upload.upload-demo(
            v-if='showUploadPdf',
            action='#',
            drag,
            :file-list='fileList',
            :limit='1',
            :on-exceed='handleExceed',
            :auto-upload='false',
            accept='.pdf',
            :on-change='onLoadFile',
            :on-remove='onRemoveFile',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100 {{ $t('laudos.arrastePdf.1') }} <em>{{ $t('laudos.arrastePdf.2') }}</em>

        el-upload.upload-demo(
            v-if='showUploadVetorial',
            action='#',
            drag,
            :file-list='fileListVetorial',
            :limit='1',
            :on-exceed='handleExceed',
            :auto-upload='false',
            :on-change='onLoadFileVetorial',
            :on-remove='onRemoveFileVetorial',
            ref='upload'
        )
            i.el-icon-upload
            .el-upload__text.w-100 {{ $t('laudos.arrastePdf.1') }} <em>{{ $t('laudos.arrastePdf.2') }}</em>

        el-form.form.p-2(
            v-if='showConfirmar',
            label-position='top',
            size='small'
        )
            el-form-item.produtor
                .label(slot='label')
                    span {{ $t('laudos.pessoas') }} *
                el-select.w-100(
                    v-model='representanteSelecionado',
                    :placeholder='$t("mensagens.comuns.selecione")',
                    clearable,
                    filterable,
                    remote,
                    reserve-keyword,
                    :remote-method='remoteMethod',
                    @change='handleChangeSelectInput($event)',
                    value-key='id',
                    ref='elselectinput'
                )
                    el-option(
                        v-for='representante in representantesCliente',
                        :key='representante.cpfCnpjRepresentante',
                        :value='representante',
                        :label='representante.nomeRazaoSocial'
                    ) {{ representante.nomeRazaoSocial }}
                    div(
                        style='display: flex; justify-content: space-between; padding: 5px'
                    )
                        el-input(
                            v-model='representante.nome',
                            :placeholder='$t("laudos.insiraNomeOuRazaoSocialDaPessoa")',
                            style='width: 70%; padding-right: 5px'
                        )

                        el-input(
                            v-model='representante.cpfCnpj',
                            :placeholder='$t("laudos.documentoDaPessoa")',
                            :class='{ "erro-borda": !cpfCnpjValido }',
                            v-mask='["###.###.###-##", "##.###.###/####-##"]',
                            style='width: 30%; padding-right: 5px'
                        )

                        BaseButton(
                            size='small',
                            type='primary',
                            icon='el-icon-plus',
                            @click='adicionarCliente'
                        )
                            | {{ $t('mensagens.comuns.adicionar') }}

            el-form-item(:label='$t("laudos.pessoaS")')
                el-select.w-100(
                    v-model='proprietariosSelecionados',
                    multiple,
                    :placeholder='$t("mensagens.comuns.selecione")',
                    filterable,
                    remote,
                    reserve-keyword,
                    :remote-method='remoteMethod',
                    @change='handleChangeSelectInput($event)',
                    value-key='id',
                    ref='elselectinput'
                )
                    el-option(
                        v-for='representante in representantesProp',
                        :key='representante.cpfCnpjRepresentante',
                        :value='representante',
                        :label='representante.nomeRazaoSocial'
                    ) {{ representante.nomeRazaoSocial }}
                    div(
                        style='display: flex; justify-content: space-between; padding: 5px'
                    )
                        el-input(
                            v-model='proprietario.nome',
                            :placeholder='$t("laudos.insiraNomeOuRazaoSocialDaPessoa")',
                            style='width: 70%; padding-right: 5px'
                        )

                        el-input(
                            v-model='proprietario.cpfCnpj',
                            :placeholder='$t("laudos.documentoDaPessoa")',
                            :class='{ "erro-borda": !cpfCnpjValido }',
                            v-mask='["###.###.###-##", "##.###.###/####-##"]',
                            style='width: 30%; padding-right: 5px'
                        )

                        BaseButton(
                            size='small',
                            type='primary',
                            icon='el-icon-plus',
                            @click='adicionarProprietario'
                        )
                            | {{ $t('mensagens.comuns.adicionar') }}

            .dados
                el-form-item
                    .label(slot='label')
                        span {{ $t('laudos.matricula') }}
                    el-input(v-model='matricula')

                el-form-item
                    .label(slot='label')
                        span {{ $t('laudos.cpr') }}
                    el-input(v-model='cpr')

                el-form-item
                    .label(slot='label')
                        span {{ $t('laudos.areaDePenhor') }}
                    el-input(v-model='areaPenhorha', type='number')

                el-form-item
                    .label(slot='label')
                        span {{ $t('laudos.numeroDeEmitentes') }} *
                    el-input-number(
                        v-model='numeroEmitentes',
                        :min='0',
                        step-strictly
                    )

                el-form-item
                    .label(slot='label', style='width: 266px')
                        span {{ $t('laudos.formatoDeExibicaoDasCoordenadas') }} *
                    el-radio-group(v-model='formatoCoordenadas')
                        el-radio-button(label='DECIMAL') {{ $t('laudos.decimal') }}
                        el-radio-button(label='GMS') {{ $t('laudos.gms') }}

    .d-flex.flex-direction.justify-content-between.py-3
        BaseButton(slot='footer', size='mini', @click='closeDialog') {{ $t('mensagens.comuns.voltar') }}
        BaseButton(
            v-if='showConfirmar',
            slot='footer',
            size='mini',
            type='primary',
            @click='confirmar'
        ) {{ $t('mensagens.comuns.confirmar') }}
</template>

<script>
import LaudosService from '@/modules/laudos/services/LaudosService';
import SelecionarTerritorio from '@/modules/laudos/components/SelecionarTerritorio.vue';
import formatters from '@/modules/laudos/utils/formatters';
import validators from '@/modules/laudos/utils/validators';
import RepresentanteService from '@/services/RepresentanteService';
import TipoLaudo from '@/modules/laudos/constants/TipoLaudo';
import axios from 'axios';
import L from 'leaflet';
import geometryConverter from '@/utils/conversorGeometrias';
import BaseButton from '@/modules/laudos/components/BaseButton.vue';

export default {
    name: 'ModalOpcoes',

    components: {
        SelecionarTerritorio,
        BaseButton
    },

    emits: ['showModalOpcoes', 'update:lista'],

    data() {
        return {
            dadosBase: null,
            tipoInsumo: null,
            showPrazo: false,
            prazo: '',
            showUploadPdf: false,
            showUploadVetorial: false,
            showSelecaoTerritorio: false,
            showConfirmar: false,
            arquivoUpload: null,
            fileList: [],
            fileListVetorial: [],
            representante: {
                nome: '',
                cpfCnpj: ''
            },
            areaPenhorha: null,
            numeroEmitentes: null,
            matricula: null,
            cpr: null,
            cpfCnpjValido: true,
            proprietario: {
                nome: null,
                cpfCnpj: null
            },
            proprietariosSelecionados: [],
            representanteSelecionado: null,
            representantesProp: [],
            representantesCliente: [],
            formatoCoordenadas: null,
            paginacao: {
                paginaAtual: 1,
                tamanhoPagina: 5
            },
            geometria: null,
            geometrias: [],
            tipoLaudoCroqui: TipoLaudo.CROQUI_LOCALIZACAO
        };
    },

    methods: {
        closeDialog() {
            this.$emit('showModalOpcoes');
            this.limpar();
        },

        async exibirOutrosCampos() {
            if (this.dadosBase && this.tipoInsumo) {
                if (
                    this.dadosBase === 'DADOS_ATUALIZADOS' ||
                    (this.dadosBase === 'DADOS_HISTORICOS' &&
                        this.tipoInsumo === 'ARQUIVO_PDF')
                ) {
                    this.prazo = '3 dias';
                } else {
                    this.prazo = 'até 3 horas';
                }
                this.showPrazo = true;

                if (this.tipoInsumo === 'TERRITORIO') {
                    this.showSelecaoTerritorio = true;
                    this.showUploadPdf = false;
                    this.showUploadVetorial = false;
                    this.showConfirmar = false;
                    this.onRemoveFileVetorial();
                    this.onRemoveFile();
                }

                if (
                    this.tipoInsumo === 'ARQUIVO_VETORIAL' ||
                    this.tipoInsumo === 'ARQUIVO_PDF'
                ) {
                    if (this.tipoInsumo === 'ARQUIVO_VETORIAL') {
                        this.showUploadPdf = false;
                        this.showUploadVetorial = true;
                        this.onRemoveFile();
                    }
                    if (this.tipoInsumo === 'ARQUIVO_PDF') {
                        this.showUploadPdf = true;
                        this.showUploadVetorial = false;
                        this.onRemoveFileVetorial();
                    }
                    this.showSelecaoTerritorio = false;
                    this.showConfirmar = true;

                    if (this.representantesProp.length === 0) {
                        await this.buscarRepresentantesEmpresa();
                    }

                    if (this.representantesProp.length === 0) {
                        let representanteInicial = {
                            id: 0,
                            nomeRazaoSocial: '',
                            cpfCnpj: ''
                        };
                        this.representantesProp.push(representanteInicial);
                        this.representantesCliente.push(representanteInicial);
                    }
                }
            }
        },

        solicitarLaudos(idsTerritoriosSelecionados) {
            let idsTerritorio = '';
            idsTerritoriosSelecionados.forEach(territorio => {
                idsTerritorio += territorio.id + '-';
            });
            let paramCroqui = {
                dadosBase: this.dadosBase,
                tipoInsumo: this.tipoInsumo
            };
            this.$router.push({
                name: 'LaudoSolicitacaoCroqui',
                params: { idsTerritorio, paramCroqui }
            });
        },

        async confirmar() {
            if (!this.arquivoUpload) {
                this.$notify.error({
                    message: this.$t('laudos.uploadDeArquivoObrigatorio')
                });
                return;
            }

            if (
                !this.formatoCoordenadas ||
                !this.numeroEmitentes ||
                this.numeroEmitentes === 0 ||
                !this.representanteSelecionado
            ) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.porFavorCompleteTodosCamposObrigatorios'
                    )
                });
                return;
            }

            let proprietarios = [];

            if (this.proprietariosSelecionados) {
                this.proprietariosSelecionados.forEach(prop => {
                    if (prop.id > 0) {
                        let proprietario = {
                            nomeProprietario: prop.nomeRazaoSocial,
                            cpfCnpjProprietario: prop.cpfCnpj
                        };
                        proprietarios.push(proprietario);
                    }
                });
            }

            let arquivoUploadNome = null;
            if (this.arquivoUpload) {
                arquivoUploadNome = [];
                arquivoUploadNome.push(this.arquivoUpload.nomeArquivo);
            }

            const matriculas = [...Array(this.matricula)];
            const informacao = {
                baseDados: this.dadosBase,
                tipoInsumo: this.tipoInsumo,
                nomeArquivos: arquivoUploadNome,
                areaPenhor:
                    this.areaPenhorha != null
                        ? this.areaPenhorha.replace(',', '.')
                        : null,
                matriculas: matriculas,
                cpr: this.cpr,
                qdeEmitentes: this.numeroEmitentes,
                nomeRepresentante:
                    this.representanteSelecionado.nomeRazaoSocial,
                cpfCnpjRepresentante: this.cpfCnpjFormatToNumeral(
                    this.representanteSelecionado.cpfCnpj
                ),
                tipoLaudoId: TipoLaudo.CROQUI_LOCALIZACAO,
                formatoCoordenadas: this.formatoCoordenadas,
                proprietarios: proprietarios,
                geoJson: this.geometrias[0]
            };

            const informacaoLaudos = [];
            informacaoLaudos.push(informacao);

            try {
                await LaudosService.validarTamanhoTerritorio({
                    informacaoLaudos
                });
            } catch (e) {
                this.$notify.info({
                    dangerouslyUseHTMLString: true,
                    message: `${this.$t(
                        'laudos.erro.areaMaiorQueLimite'
                    )} &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    ${this.$t('laudos.erro.suporteEmail')}`
                });
                return;
            }

            try {
                await LaudosService.cadastrarLaudos({ informacaoLaudos });

                this.closeDialog();

                this.$notify.success({
                    message: this.$t('laudos.solicitacaoRealizadaComSucesso')
                });

                setTimeout(this.atualizarTabela, 1000);
            } catch (e) {
                this.$notify.error({
                    message: this.$t('laudos.erro.erroAoCadastrarLaudo')
                });
            }
        },

        getFiltros(query) {
            const filtro = {};
            filtro.page = this.paginacao.paginaAtual - 1;
            filtro.size = this.paginacao.tamanhoPagina;
            filtro.searchText = query || '';
            if (validators.validarCPF(query)) {
                filtro.searchText = formatters.documentoFormatToNumeral(query);
            }
            filtro.order = '&sort=nome_razao_social,asc';
            return filtro;
        },

        async buscarRepresentantesEmpresa(query) {
            try {
                const { data } = await RepresentanteService.findAllByFiltro(
                    this.getFiltros(query)
                );
                this.representantesProp = data.resultados;
                this.representantesCliente = data.resultados;
            } catch (error) {
                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.naoFoiPossivelCarregarOsDadosDasPessoas'
                    )
                });
            }
        },

        numeralStringFormatTocpfCnpj(value) {
            return formatters.numeralStringFormatToDocumento(value);
        },

        cpfCnpjFormatToNumeral(value) {
            return formatters.documentoFormatToNumeral(value);
        },

        async onLoadFile(file, fileList) {
            let url = process.env.VUE_APP_HTTP_PATH + '/laudo/upload-temp';
            let formData = new FormData();
            formData.append('file', file.raw);
            const { data, status } = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (status === 200) {
                const arq = { nomeArquivo: data, uid: file.uid };
                this.arquivoUpload = arq;
            } else {
                this.$notify.error({
                    message: this.$t('laudos.erro.naoFoiPossivelEnviarArquivo')
                });
            }
        },
        async onRemoveFile(file, fileList) {
            if (this.arquivoUpload) {
                const { status } = await LaudosService.removerArquivoTemp(
                    this.arquivoUpload.nomeArquivo
                );
                if (status === 200) {
                    this.arquivoUpload = null;
                    this.fileList = [];
                    return true;
                } else {
                    this.$notify.warning({
                        message: this.$t(
                            'laudos.erro.naoFoiPossivelDeletarArquivo'
                        )
                    });
                    return false;
                }
            }
        },

        async onLoadFileVetorial(file, fileListVetorial) {
            await this.onLoadFile(file, fileListVetorial);

            let reader = new FileReader();

            let extension = file.name.split('.').pop().toLowerCase();

            reader.onload = async e => {
                geometryConverter
                    .read(extension, e.target.result, file.raw)
                    .then(geometria => {
                        this.processarGeometria(geometria);

                        this.geometria = geometria;
                    })
                    .catch(rejectReason => {
                        this.arquivoUpload = null;
                        this.fileListVetorial = [];
                        this.geometria = null;
                        this.geometrias = [];
                        this.$notify.error({ message: rejectReason });
                    });
            };

            reader.readAsText(file.raw);
        },

        processarGeometria(geometria) {
            this.filtrarGeometrias(geometria);
            if (geometria !== null && geometria.getLayers().length > 0) {
                if (
                    geometria.getLayers()[0].feature.geometry.type ===
                    'GeometryCollection'
                ) {
                    _.each(geometria.getLayers()[0].getLayers(), layer =>
                        this.processarLayer(layer)
                    );
                } else {
                    _.each(geometria.getLayers(), layer =>
                        this.processarLayer(layer)
                    );
                }
            } else {
                this.arquivoUpload = null;
                this.fileListVetorial = [];
                this.geometria = null;
                this.geometrias = [];

                this.$notify.error({
                    message: this.$t(
                        'laudos.erro.arquivoNaoPossuiGeometriaValida'
                    )
                });
            }
        },

        filtrarGeometrias(layerGeometrias) {
            if (layerGeometrias === null) return;

            if (layerGeometrias.getLayers) {
                layerGeometrias.getLayers().forEach(layer => {
                    if (!(layer instanceof L.Polygon)) {
                        if (layer instanceof L.LayerGroup) {
                            return this.filtrarGeometrias(layer);
                        }
                        layerGeometrias.removeLayer(layer);
                    }
                });
            } else {
                if (!(layerGeometrias instanceof L.Polygon)) {
                    return L.featureGroup();
                }
            }
        },

        processarLayer(layer) {
            this.geometrias.push(layer.toGeoJSON().geometry);
        },

        async onRemoveFileVetorial(file, fileListVetorial) {
            this.arquivoUpload = null;
            this.fileListVetorial = [];
            this.geometria = null;
            this.geometrias = [];
        },

        handleExceed() {
            this.$notify.warning(this.$t('laudos.limiteDeUmArquivo'));
        },

        adicionarProprietario() {
            if (!this.proprietario.nome && !this.proprietario.cpfCnpj) {
                this.$notify.error({
                    message: this.$t('laudos.erro.informeCpfCnpjParaIncluir')
                });
                return;
            }

            let rep = {
                nomeRazaoSocial: this.proprietario.nome,
                cpfCnpj: this.cpfCnpjFormatToNumeral(this.proprietario.cpfCnpj),
                id: Math.floor(Math.random() * 10000000)
            };

            this.proprietariosSelecionados.push(rep);
            this.representantesProp.push(rep);

            this.proprietario = {
                nome: null,
                cpfCnpj: null
            };
        },

        adicionarCliente() {
            if (!this.representante.nome && !this.representante.cpfCnpj) {
                this.$notify.error({
                    message: this.$t('laudos.erro.informeCpfCnpjParaIncluir')
                });
                return;
            }

            let cliente = {
                nomeRazaoSocial: this.representante.nome,
                cpfCnpj: this.cpfCnpjFormatToNumeral(
                    this.representante.cpfCnpj
                ),
                id: Math.floor(Math.random() * 10000000)
            };

            this.representantesCliente.push(cliente);

            this.representante = {
                nome: null,
                cpfCnpj: null
            };
        },

        remoteMethod(query) {
            setTimeout(() => {
                this.buscarRepresentantesEmpresa(query);
            }, 800);
        },

        handleChangeSelectInput() {
            this.$nextTick(() => {
                this.$refs.elselectinput.query = '';
            });
        },

        atualizarTabela() {
            this.$emit('update:lista');
        },

        limpar() {
            this.arquivoUpload = null;
            this.fileListVetorial = [];
            this.geometria = null;
            this.geometrias = [];
            this.dadosBase = null;
            this.tipoInsumo = null;
            this.showPrazo = false;
            this.prazo = '';
            this.showUploadPdf = false;
            this.showUploadVetorial = false;
            this.showSelecaoTerritorio = false;
            this.showConfirmar = false;
            this.arquivoUpload = null;
            this.fileList = [];
            this.representante = {
                nome: '',
                cpfCnpj: ''
            };
            this.areaPenhorha = null;
            this.numeroEmitentes = null;
            this.cpr = null;
            this.cpfCnpjValido = true;
            this.proprietario = {
                nome: null,
                cpfCnpj: null
            };
            this.proprietariosSelecionados = [];
            this.representanteSelecionado = null;
            this.representantesProp = [];
            this.representantesCliente = [];
            this.formatoCoordenadas = null;
            this.paginacao = {
                paginaAtual: 1,
                tamanhoPagina: 5
            };
        }
    }
};
</script>

<style lang="scss" scoped>
#modal-opcoes-laudo {
    .el-dialog__footer {
        margin-top: -30px;
        display: flex;
        justify-content: flex-start;
    }

    .el-upload,
    .el-upload--text,
    .el-upload-dragger {
        width: 100%;
    }

    .negrito {
        font-weight: bold;
    }

    .form {
        .produtor .representante .input {
            display: flex;
            justify-content: space-between;

            .nome {
                width: 66%;
            }

            .cpfCnpj {
                width: 33%;
            }
        }

        .dados {
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            gap: 8px;
            width: 100% !important;
            padding: 0px !important;

            .el-input,
            .el-select,
            .el-date-picker {
                width: 150px;
            }
        }
    }

    .el-input-number.el-input-number--small {
        width: 152px !important;
    }

    .radio-group-container {
        display: flex;
        flex-direction: column;
    }
}
</style>
